import { IAxiosResponse, IPaginator } from '../store/ducks/root.types'
import { TimeSeriesSimpleFilter } from '../store/application/models/time.series/filters/simple.filter'
import Report from '../store/application/models/report/report'
import axiosInstance from './axios'

class ReportService {

  constructor(private apiVersion: string = 'v1') {
  }
  public async create(report: Report): Promise<any> {

    const formData = new FormData()
    for (const [key, value] of Object.entries(report)) {
      if (value !== undefined) {
        
        if ( typeof value === 'string') {
          formData.set(key, value.toLowerCase())
        }
        else {
          formData.set(key, value)
        }
      }
    }

    return axiosInstance
      .post(`${this.apiVersion}/patients/${report.patient_id}/reports`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      })
      .then(response => new Report().fromJSON(response.data))

  }
  public async getAll(
    patientId: string,
    paginator?: IPaginator,
    filter?: TimeSeriesSimpleFilter
  ): Promise<IAxiosResponse<Report[]>> {
    const params: URLSearchParams = this.buildParams(paginator, filter)
   
    return axiosInstance
      .get(`${this.apiVersion}/patients/${patientId}/reports`, { params })
      .then((response) => {
        return {
          data: response.data.map((data: any) => new Report().fromJSON(data)),
          headers: response.headers
        }
      })
  }

  public remove(patientId: string, reportId: string) {
    return axiosInstance
      .delete(`${this.apiVersion}/patients/${patientId}/reports/${reportId}`)
  }

  public buildParams(paginator?: IPaginator, filter?: TimeSeriesSimpleFilter): URLSearchParams {
    const params = new URLSearchParams()
    
    if (paginator) {
      if (paginator.page) {
        params.append('page', String(paginator.page + 1))
      }

      if (paginator.rows) {
        params.append('limit', String(paginator.rows))
      }
    }

    if (filter?.start_date) {
      const endDate = filter?.end_date ? filter?.end_date : filter?.start_date
      
      params.append('created_at', `gte:${filter?.start_date}T00:00:00`)
      params.append('created_at', `lte:${endDate}T23:59:59`)
    }

    return params
  }
}

export default new ReportService()
